import { createContext, useContext, useState, useCallback, useEffect } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CoffeeContext = createContext(null);

export function CoffeeProvider({ children }) {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/coffee/status");
      setStatus(data);
    } catch {
      /* silencioso */
    }
  }, []);

  useEffect(() => {
    if (user) refresh();
    else setStatus(null);
  }, [user, refresh]);

  return (
    <CoffeeContext.Provider value={{ status, refresh }}>{children}</CoffeeContext.Provider>
  );
}

export const useCoffee = () => useContext(CoffeeContext);
